export default __webpack_public_path__ + "static/media/Logo.a8c80e22.png";